export default __webpack_public_path__ + "static/media/assassinBg.04a2d122.png";